import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PromoBar } from './components/PromoBar';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { TrustSection } from './components/TrustSection';
import { ServicesSection } from './components/ServicesSection';
import { BeforeAfter } from './components/BeforeAfter';
import { SeasonsSection } from './components/SeasonsSection';
import { ServiceArea } from './components/ServiceArea';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
// Heights: promo bar ~40px, nav ~64px (scrolled) / ~80px (default)
const PROMO_H = 40;
const NAV_H = 72;
export function App() {
  const [promoVisible, setPromoVisible] = useState(true);
  const totalOffset = (promoVisible ? PROMO_H : 0) + NAV_H;
  return <div className="min-h-screen bg-white font-body" data-id="element-0">
      {/* Fixed promo bar — only hides on user X click */}
      <AnimatePresence data-id="element-1">
        {promoVisible && <motion.div initial={{
        height: PROMO_H,
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.35,
        ease: [0.22, 1, 0.36, 1]
      }} style={{
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 60
      }} data-id="element-2">
            <PromoBar onClose={() => setPromoVisible(false)} data-id="element-3" />
          </motion.div>}
      </AnimatePresence>

      {/* Navigation sits directly below the promo bar */}
      <Navigation promoVisible={promoVisible} data-id="element-4" />

      {/* Main content — offset by promo + nav height so nothing is hidden under fixed bars */}
      <main style={{
      paddingTop: totalOffset
    }} data-id="element-5">
        <Hero data-id="element-6" />
        <TrustSection data-id="element-7" />
        <ServicesSection data-id="element-8" />
        <BeforeAfter data-id="element-9" />
        <SeasonsSection data-id="element-10" />
        <ServiceArea data-id="element-11" />
        <ContactForm data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}